export enum MetafieldKeys {
  RATING = "rating",
}

export enum MetafieldNamespaces {
  REVIEWS = "reviews",
}

export interface Metafield {
  key: string;
  namespace: string;
  value: string;
}
